import React, {useCallback, useState} from 'react'
import {useMultiStyleConfig} from '@salesforce/retail-react-app/app/components/shared/ui'
import PropTypes from 'prop-types'

import {styleConfigChakraKeys} from '../../../constants'
import Link from '../../link'
import Search from '../../search'
import {useIntl} from 'react-intl'

const SearchAction = ({search, hasActiveAnnouncementBar}) => {
    const intl = useIntl()
    const [searchShow, setSearchShow] = useState(false)
    const [enableAnimation, setEnableAnimation] = useState(false)
    const styles = useMultiStyleConfig(styleConfigChakraKeys.header)

    const placeholder = intl.formatMessage({
        id: 'header.field.placeholder.search',
        defaultMessage: 'SEARCH'
    })

    const onSearchClick = useCallback(() => {
        setSearchShow((prevState) => !prevState)
        setEnableAnimation(true)
    }, [])

    return (
        <>
            {searchShow && (
                <Search
                    aria-label={placeholder}
                    placeholder={placeholder}
                    {...styles.searchBar}
                    searchOpen={setSearchShow}
                    searchShow={searchShow}
                    enableAnimation={enableAnimation}
                    hasActiveAnnouncementBar={hasActiveAnnouncementBar}
                />
            )}
            <Link
                onLinkClick={onSearchClick}
                id="search-icon-btn"
                display={{xl: searchShow ? 'none' : 'block'}}
                icon={search?.iconName}
                iconStyles={styles.searchIcon}
                buttonStyles={{
                    ...styles.iconBtn,
                    _hover: {
                        filter: 'brightness(0) saturate(100%) invert(99%) sepia(3%) saturate(1625%) hue-rotate(308deg) brightness(86%) contrast(85%)'
                    }
                }}
                type={search?.type || 'tertiary'}
                _active={{background: 'unset'}}
            />
        </>
    )
}

SearchAction.propTypes = {
    search: PropTypes.object,
    hasActiveAnnouncementBar: PropTypes.bool
}

export default SearchAction
